export default [
  {
    component: () => import('../pages/entities/[entityId].vue'),
    name: 'filing.entity.files-system',
    path: '/:slug/filing/:entity_type/:entity_id/files-system',
  },
  {
    component: () => import('../pages/individuals/[individualId].vue'),
    name: 'filing.individual.files-system',
    path: '/:slug/filing/individual/:individual_id/files-system',
  },
  {
    component: () => import('../pages/associatedEntities/[associatedEntityId].vue'),
    name: 'filing.associated-entity.files-system',
    path: '/:slug/filing/associated-entity/:associated_entity_id/files-system',
  },
  {
    component: () => import('../pages/groups/index.vue'),
    name: 'filing.group.files-system',
    path: '/:slug/filing/files-system',
  },
]
